import {AxiosError} from 'axios'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {httpEditEvent, HttpEditEventOptions} from '@/features/agenda/http/agenda.http'

export const useEditEvent = (options?: UseMutationOptions<unknown, AxiosError, HttpEditEventOptions>) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.EDIT_EVENT],
        mutationFn: httpEditEvent,
        onSuccess: async (data, variables, context) => {
            for (const event of data) {
                await queryClient.cancelQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS, 'extended', event.id]})
                await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS, 'extended', event.id]})
                for (const patient of event.eventPatients ?? []) {
                    void queryClient.cancelQueries({queryKey: [QUERY_KEYS.PATIENTS, patient.patientId]})
                }
            }

            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_AVAILABILITIES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT_ACCESS_COUNTERS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            // Banner-scoped events query (see ProjectWarningMissingActionBanner): invalidate it so the
            // warning banner re-checks event presence/completion after editing an event (e.g. marking
            // the "Valutazione iniziale progetto" event as completed must clear its banner).
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS, 'project-warning-banner']})

            for (const event of data) {
                for (const patient of event.eventPatients ?? []) {
                    void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, patient.projectId]})
                }
            }

            options?.onSuccess?.(data, variables, context)
        }
    })
}
